// noinspection JSSuspiciousNameCombination

export function calcAlign(outerDiv: JQuery<HTMLElement>, innerDiv: JQuery<HTMLElement>, paddingTop?: number, paddingRight?: number, paddingBottom?: number, paddingLeft?: number): {
    x: number,
    y: number
} {
    if (typeof paddingTop !== "number") paddingTop = 0;
    if (typeof paddingRight !== "number") paddingRight = paddingTop;
    if (typeof paddingBottom !== "number") paddingBottom = paddingTop;
    if (typeof paddingLeft !== "number") paddingLeft = paddingRight;

    const r = {x: 0, y: 0};

    const ox = outerDiv.offset().left;
    const oy = outerDiv.offset().top;
    const ow = outerDiv.width();
    const oh = outerDiv.height();
    const ix = innerDiv.offset().left - paddingLeft;
    const iy = innerDiv.offset().top - paddingTop;
    const iw = innerDiv.outerWidth(true) + paddingLeft + paddingRight;
    const ih = innerDiv.outerHeight(true) + paddingTop + paddingBottom;

    let i = (ix + iw - ox - ow) | 0;
    if (i > 0) r.x = i;
    i = (ox - ix) | 0;
    if (i > 0) r.x = -i;
    i = (iy + ih - oy - oh) | 0;
    if (i > 0) r.y = i;
    i = (oy - iy) | 0;
    if (i > 0) r.y = -i;

    return r;
}
